import { createSlice } from "@reduxjs/toolkit";
import { getDealStatusList } from "../reduxApi/dealStatusReduxApi";

const dealStatusSlice = createSlice({
    name: 'dealStatus',
    initialState: {
        status: 'idel',
        isFiltered: false,
        dealStatus: [],
    },
    reducers: {
         setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteDealStatusAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.dealStatus.findIndex((item) => item.dealStatus.ROWID === id);
                if (index !== -1) {
                    state.dealStatus.splice(index, 1);
                }
            });
        },
        updateDealStatusAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.dealStatus.findIndex((item) => item.dealStatus.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.dealStatus.splice(index, 1, { dealStatus: action.payload })
            }
        },
        addDealStatusAction: (state, action) => {
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.dealStatus.unshift({ dealStatus: temp });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getDealStatusList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getDealStatusList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.dealStatus = action.payload.data.response;
            })
    }
})
export const { deleteDealStatusAction, updateDealStatusAction, addDealStatusAction,setFilteredStatus } = dealStatusSlice.actions
export default dealStatusSlice.reducer